module.exports = __webpack_public_path__ + "img/image-028.13a64d35.png";